import Header from "./main/Header";

import "./assets/css/home.scss";

import Footer from "./main/Footer";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes/Routes";
import WithAuthentication from "Authentication/WithAuthentication.tsx";
import WithPageTitle from "utilities/withPageTitle";
import toast, { Toaster } from "react-hot-toast";
function App() {
  return (
    <div className="App">
      <Toaster />
      <WithAuthentication>
        <BrowserRouter>
          <WithPageTitle>
            <Header></Header>

            <Router> </Router>

            <Footer></Footer>
          </WithPageTitle>
        </BrowserRouter>
      </WithAuthentication>
    </div>
  );
}

export default App;
